import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import Chip from '@material-ui/core/Chip';
import { useRouter } from 'next/router';
import Paper from '@material-ui/core/Paper';
import {
  getDocs,
  limit,
  collection,
  orderBy,
  query,
  startAfter,
  where,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { isEmpty } from '../../helpers/regex';
import NftCard from '../Card/NftCard';
import { useMediaQuery } from '@material-ui/core';
import moment from 'moment';

const skeleTonJson = [
  {
    tokenId: 'loader1',
    tokenName: 'loading',
    icons: null,
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader2',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader3',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader4',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader5',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader6',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader7',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
  {
    tokenId: 'loader8',
    icons: null,
    tokenName: 'loading',
    artistId: 'loading',
    nftSaleType: 'loading',
    auctionEndTime: 'loading',
    startingPrice: 'loading',
    price: 'loading',
  },
];

let backedNftArr = [];
let artists = {};
let startAfterDoc = null;
let sortParam = {
  sortingField: 'creationDate',
  sortingOrder: 'desc',
};
let stopUpdate = false;
let callNo = 0;

let roomFilterBacked = false;
let filterEnabled = false;

export default function NFTsContainer(props) {
  const isMobile = useMediaQuery('(max-width:1000px)');
  const router = useRouter();

  let {
    collection: collectionFilter,
    room: roomFilter,
    searchQuery: searchQuery,
    filter: filter,
    price: priceFilter,
    category: categoryFilter,
    sortBy: sortBy,
  } = router.query;

  const [nftDataArr, setNFTDataArr] = useState([]);
  const [loadingNfts, setloadingNfts] = useState(false);
  const [hardLoad, sethardLoad] = useState(false);
  const [hasMore, sethasMore] = useState(true);
  const [filters, setfilters] = useState([]);

  //filter labels
  const [priceFilterLabel, setpriceFilterLabel] = useState('');
  const [calledonce, setCalledonce] = useState(false);

  useEffect(() => {
    return () => {
      // Executed only when component unmounts,
      backedNftArr = [];
      startAfterDoc = null;
      stopUpdate = false;
      callNo = 0;
      roomFilterBacked = false;
      sortParam = {
        sortingField: 'creationDate',
        sortingOrder: 'desc',
      };
    };
  }, []);

  const getArtists = async () => {
    const musicartArtistsRef = await getDocs(
      query(collection(firebaseFireStore, 'musicartArtists')),
    );

    musicartArtistsRef.forEach((doc) => {
      const data = doc.data();
      artists[data.id] = Object.assign(artists[data.id] || {}, data);
    });
  };

  const getMarketPlaceData = async (hard, lcallNo) => {
    const callNoVal = lcallNo;
    if (!loadingNfts || hard) {
      setloadingNfts(true);
      isEmpty(artists) && (await getArtists());

      console.log('getmarketplace data');

      let queryArr = [];
      let docObj = startAfterDoc ? startAfterDoc.data() : null;

      queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
      queryArr.push(where('adminState', '==', 'ACCEPT'));
      queryArr.push(where('activeInMarketPlace', '==', true));
      if (roomFilter) {
        let roomsArr = roomFilter
          ? Array.isArray(roomFilter)
            ? [...roomFilter]
            : [roomFilter]
          : [];

        queryArr.push(where('roomIds', 'array-contains-any', roomsArr));
      }

      //music and artwork filters
      let musicFilter = !filter || (filter && !filter.includes('NA-Music'));
      let artWorkFilter = filter && filter.includes('Artwork and More');

      if (musicFilter && !artWorkFilter) {
        queryArr.push(where('category', '==', 'Music'));
      }

      queryArr.push(orderBy(sortParam.sortingField, sortParam.sortingOrder));
      if (docObj) {
        queryArr.push(startAfter(startAfterDoc));
      }
      queryArr.push(limit(8));

      if (!stopUpdate || hard) {
        // let dataRef2 = await getDocs(q);
        let dataRef2 = await getDocs(query(...queryArr));

        if (stopUpdate && !hard) {
          return null;
        }
        if (hard) {
          console.log('callNoVal', callNoVal, callNo);
        }
        if (hard && callNoVal && callNo && callNoVal !== callNo) {
          return null;
        }

        if (dataRef2.empty) {
          // if (backedNftArr.length !== nftDataArr.length) {
          let dataArr = [...backedNftArr];
          filterDataLocally(dataArr);
          // }
          sethasMore(false);
          setloadingNfts(false);

          return;
        }

        let dataLen =
          dataRef2 && dataRef2.docs && dataRef2.docs.length
            ? dataRef2.docs.length
            : 8;
        let dataArr = [...backedNftArr];

        dataRef2.docs.map((doc, keyIndex) => {
          if (dataLen && dataLen - 1 === keyIndex) {
            console.log('update start afer val');
            startAfterDoc = doc;
          }

          let cObj = doc.data();
          if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
            let startingPrice = 0;
            Object.values(cObj.multipleNftDetails)
              .filter((x) => x.activeInMarketPlace)
              .map((ele, index) => {
                if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
                  if (
                    ele.nftSaleType &&
                    ele.nftSaleType !== 'Auctioning' &&
                    ele.price &&
                    (!startingPrice ||
                      (startingPrice && Number(ele.price) < startingPrice))
                  ) {
                    startingPrice = Number(ele.price);
                  } else if (
                    ele.nftSaleType &&
                    ele.nftSaleType === 'Auctioning' &&
                    ele.auctionEndTime &&
                    ele.minBiddingPrice &&
                    (!startingPrice ||
                      (startingPrice &&
                        Number(ele.minBiddingPrice) < startingPrice))
                  ) {
                    startingPrice = Number(ele.minBiddingPrice);
                  }
                }
              });
            if (
              startingPrice
              // || cObj.preview
            ) {
              dataArr.push({
                ...cObj,
                startingPrice: startingPrice,
                artistDetail: artists[cObj.artistId]
                  ? artists[cObj.artistId]
                  : [],
              });
            }
          } else {
            if (
              (cObj.nftSaleType &&
                cObj.nftSaleType === 'Auctioning' &&
                cObj.auctionEndTime &&
                cObj.minBiddingPrice &&
                cObj.activeInMarketPlace &&
                Number(moment().format('x')) < Number(cObj.auctionEndTime)) ||
              (cObj.nftSaleType !== 'Auctioning' && cObj.price) ||
              cObj.preview
            ) {
              dataArr.push({
                ...cObj,
                artistDetail: artists[cObj.artistId]
                  ? artists[cObj.artistId]
                  : [],
              });
            }
          }
        });

        if (
          dataArr.length === backedNftArr.length &&
          dataRef2.docs.length < 8
        ) {
          if (backedNftArr.length !== nftDataArr.length) {
            let dataArr = [...backedNftArr];
            filterDataLocally(dataArr);
          }
          sethasMore(false);
          setloadingNfts(false);

          return;
        }

        backedNftArr = [...dataArr];

        filterDataLocally(dataArr);

        setCalledonce(true);

        if (stopUpdate) {
          stopUpdate = false;
        }
      }

      setloadingNfts(false);
    }
  };

  const filterDataLocally = (nftdataArrParam) => {
    console.log('start filter');
    let dataArr = [...(nftdataArrParam ? nftdataArrParam : backedNftArr)];
    let filtersArr = [];

    //search
    let searchVal = searchQuery;
    if (searchVal && searchVal !== '' && searchVal !== -1) {
      dataArr = dataArr.filter((x) => {
        if (
          (x.tokenName &&
            x.tokenName.toLowerCase().includes(searchVal.toLowerCase())) ||
          (x.thumbnailDesc &&
            x.thumbnailDesc.toLowerCase().includes(searchVal.toLowerCase())) ||
          (x.artistDetail.name &&
            x.artistDetail.name.toLowerCase().includes(searchVal.toLowerCase()))
        ) {
          return x;
        }
      });
      if (!filtersArr.includes('SEARCH_FILTER')) {
        filtersArr.push('SEARCH_FILTER');
      }
    }

    //sale type filter
    let lbuyNowFilter = filter && filter.includes('BuyNow');
    let lauctionFilter = filter && filter.includes('Auction');
    let lartWorkFilter = filter && filter.includes('Artwork and More');
    let lmusicFilter = !filter || (filter && !filter.includes('NA-Music'));

    if (lbuyNowFilter) {
      dataArr = dataArr.filter((x) => {
        if (x.isMultiple && x.multipleNftDetails) {
          let pass = false;
          Object.values(x.multipleNftDetails).map((multiEle) => {
            if (
              multiEle.activeInMarketPlace &&
              multiEle.nftSaleType === 'SalePrice'
            ) {
              pass = true;
            }
          });
          return pass;
        } else {
          return x.activeInMarketPlace && x.nftSaleType === 'SalePrice';
        }
      });
    } else if (lauctionFilter) {
      dataArr = dataArr.filter((x) => {
        if (x.isMultiple && x.multipleNftDetails) {
          let pass = false;
          Object.values(x.multipleNftDetails).map((multiEle) => {
            if (
              multiEle.activeInMarketPlace &&
              multiEle.nftSaleType === 'Auctioning' &&
              Number(moment().format('x')) < Number(multiEle.auctionEndTime)
            ) {
              pass = true;
            }
          });
          return pass;
        } else {
          return (
            x.activeInMarketPlace &&
            x.nftSaleType === 'Auctioning' &&
            Number(moment().format('x')) < Number(x.auctionEndTime)
          );
        }
      });
    }
    if (lbuyNowFilter && lauctionFilter) {
      dataArr = dataArr.filter((x) => {
        if (x.isMultiple && x.multipleNftDetails) {
          let pass = false;
          Object.values(x.multipleNftDetails).map((multiEle) => {
            if (
              multiEle.activeInMarketPlace &&
              (multiEle.nftSaleType === 'Auctioning' ||
                multiEle.nftSaleType === 'SalePrice')
            ) {
              pass = true;
            }
          });
          return pass;
        } else {
          return (
            (x.activeInMarketPlace && x.nftSaleType === 'Auctioning') ||
            (x.activeInMarketPlace && x.nftSaleType === 'SalePrice')
          );
        }
      });
    }

    if (lbuyNowFilter) {
      filtersArr.push('Buy Now');
    }
    if (lauctionFilter) {
      filtersArr.push('On Auction');
    }
    if (lartWorkFilter) {
      filtersArr.push('Artwork and More');
    }

    if (lartWorkFilter && !lmusicFilter) {
      dataArr = dataArr.filter((x) => {
        if (x.category !== 'Music') {
          return true;
        } else {
          return false;
        }
      });
    }

    //price filter
    let priceVal = [null, null];
    if (priceFilter && priceFilter[0] !== '') {
      priceVal[0] = Number(priceFilter[0]);
    }
    if (priceFilter && priceFilter[1] !== '') {
      priceVal[1] = Number(priceFilter[1]);
    }

    if (priceVal && (priceVal[0] || priceVal[1])) {
      dataArr = dataArr.filter((x) => {
        let xPrice;
        if (x.isMultiple) {
          xPrice = Number(x.startingPrice);
        } else {
          xPrice =
            x.nftSaleType && x.nftSaleType === 'Auctioning' && x.minBiddingPrice
              ? x.minBiddingPrice
              : x.price;
        }

        if (priceVal[0] && priceVal[1]) {
          if (xPrice >= priceVal[0] && xPrice <= priceVal[1]) {
            return x;
          }
        } else if (priceVal[0] && xPrice >= priceVal[0]) {
          return x;
        } else if (priceVal[1] && xPrice <= priceVal[1]) {
          return x;
        }
      });
      if (!filtersArr.includes('PRICE_FILTER')) {
        filtersArr.push('PRICE_FILTER');
      }

      let priceLabel;
      if (priceVal[0] && priceVal[1]) {
        priceLabel = `$${priceVal[0]} - $${priceVal[1]}`;
      } else if (priceVal[0]) {
        priceLabel = `> $${priceVal[0]}`;
      } else if (priceVal[1]) {
        priceLabel = `< $${priceVal[1]}`;
      }

      setpriceFilterLabel(priceLabel);
    }

    //category filter
    let categoryArr = categoryFilter
      ? Array.isArray(categoryFilter)
        ? [...categoryFilter]
        : [categoryFilter]
      : null;
    if (categoryArr && categoryArr.length > 0) {
      dataArr = dataArr.filter((x) => {
        if (x.category && categoryArr.includes(x.category)) {
          return x;
        }
      });

      categoryArr.map((a, b) => {
        if (!filtersArr.includes('CATEGORY-' + a)) {
          filtersArr.push('CATEGORY-' + a);
        }
      });
    }

    //collections filter
    let collectionsArr = collectionFilter
      ? Array.isArray(collectionFilter)
        ? [...collectionFilter]
        : [collectionFilter]
      : null;
    if (collectionsArr && collectionsArr.length > 0) {
      dataArr = dataArr.filter((x) => {
        if (
          x.collection &&
          collectionsArr.includes(x.collection.toLowerCase())
        ) {
          return x;
        }
      });
      collectionsArr.map((a, b) => {
        if (!filtersArr.includes('COLLECTION-' + a)) {
          filtersArr.push('COLLECTION-' + a);
        }
      });
    }

    //room filter
    let roomsArr = roomFilter
      ? Array.isArray(roomFilter)
        ? [...roomFilter]
        : [roomFilter]
      : null;
    if (roomsArr && roomsArr.length > 0) {
      let issuerIds = [];
      roomsArr.map((roomId) => {
        let roomEleIndex = props.roomDataArr.findIndex((x) => roomId === x.id);
        if (roomEleIndex !== -1) {
          issuerIds = issuerIds.concat(props.roomDataArr[roomEleIndex].RoomID);

          let roomFilterId =
            'ROOM-' +
            roomId +
            '-RoomName%<{}%:-' +
            props.roomDataArr[roomEleIndex].RoomName;

          if (!filtersArr.includes(roomFilterId)) {
            filtersArr.push(roomFilterId);
          }
        }
      });

      // dataArr = dataArr.filter((x) => {
      //   if (x.issuerID && issuerIds.includes(x.issuerID)) {
      //     return x;
      //   }
      // });
    }

    setfilters(filtersArr);
    setNFTDataArr(dataArr);
  };
  const renderChips = () => {
    // return chips;
    return filters.map((ele, index) => {
      if (ele === 'SEARCH_FILTER' && searchQuery) {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={searchQuery}
              onDelete={() => {
                onDeleteFilter(index);

                //remove search filter
                props.updateSearchInputEl('');
                props.updateRoute(['searchQuery', ''], 'remove');
              }}
            />
          </li>
        );
      } else if (ele === 'Artwork and More') {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={'Artwork and More'}
              onDelete={() => {
                onDeleteFilter(index);

                props.updateRoute(
                  ['filter', 'Artwork and More'],
                  'removeFromArr',
                );
              }}
            />
          </li>
        );
      } else if (ele === 'Buy Now') {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={'Buy Now'}
              onDelete={() => {
                onDeleteFilter(index);

                props.updateRoute(['filter', 'BuyNow'], 'removeFromArr');
              }}
            />
          </li>
        );
      } else if (ele === 'On Auction') {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={'On Auction'}
              onDelete={() => {
                onDeleteFilter(index);

                props.updateRoute(['filter', 'Auction'], 'removeFromArr');
              }}
            />
          </li>
        );
      } else if (ele === 'PRICE_FILTER') {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={priceFilterLabel}
              onDelete={() => {
                onDeleteFilter(index);
                props.updateRoute(['price', ''], 'remove');
              }}
            />
          </li>
        );
      } else if (ele.includes('CATEGORY-')) {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={ele.slice(9, ele.length)}
              onDelete={() => {
                onDeleteFilter(index);

                let modifiedArr = categoryFilter
                  ? Array.isArray(categoryFilter)
                    ? [...categoryFilter]
                    : [categoryFilter]
                  : [];
                let indx = modifiedArr.indexOf(ele.slice(9, ele.length));
                if (indx !== -1) {
                  modifiedArr.splice(indx, 1);
                }

                if (modifiedArr && modifiedArr.length > 0) {
                  props.updateRoute(['category', modifiedArr], 'addToArr');
                } else {
                  props.updateRoute(['category', ''], 'remove');
                }
              }}
            />
          </li>
        );
      } else if (ele.includes('COLLECTION-')) {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={ele.slice(11, ele.length)}
              onDelete={() => {
                onDeleteFilter(index);
                let modifiedArr = collectionFilter
                  ? Array.isArray(collectionFilter)
                    ? [...collectionFilter]
                    : [collectionFilter]
                  : [];

                let indx = modifiedArr.indexOf(ele.slice(11, ele.length));
                if (indx !== -1) {
                  modifiedArr.splice(indx, 1);
                }

                if (modifiedArr && modifiedArr.length > 0) {
                  props.updateRoute(['collection', modifiedArr], 'addToArr');
                } else {
                  props.updateRoute(['collection', ''], 'remove');
                }
              }}
            />
          </li>
        );
      } else if (ele.includes('ROOM-')) {
        return (
          <li key={'chip' + index}>
            <Chip
              className="chip_box capitalize"
              label={ele.slice(
                ele.indexOf('-RoomName%<{}%:-') + 16,
                ele.length,
              )}
              onDelete={() => {
                onDeleteFilter(index);

                let modifiedArr = roomFilter
                  ? Array.isArray(roomFilter)
                    ? [...roomFilter]
                    : [roomFilter]
                  : [];

                let indx = modifiedArr.indexOf(
                  ele.slice(5, ele.indexOf('-RoomName%<{}%:-')),
                );
                if (indx !== -1) {
                  modifiedArr.splice(indx, 1);
                }

                if (modifiedArr && modifiedArr.length > 0) {
                  props.updateRoute(['room', modifiedArr], 'addToArr');
                } else {
                  props.updateRoute(['room', ''], 'remove');
                }
              }}
            />
          </li>
        );
      }
    });
  };
  const onDeleteFilter = (index) => {
    let arr = [...filters];
    arr.splice(index, 1);
    setfilters(arr);
  };

  const clearAll = () => {
    props.updateSearchInputEl('');

    props.setRoomLoader(false);
    sethasMore(true);

    // props.setcollectionsList(alpaarr);

    router.push({
      pathname: '/discover',
    });
  };

  useEffect(() => {
    if (router.isReady) {
      console.log('router.query updated');
      stopUpdate = true;
      callNo = callNo + 1;
      updateSortParam();
      updateRoomParam();
      updateFilterParam();

      getData();
    }
  }, [router.query, router.isReady, sortBy]);

  const updateFilterParam = async () => {
    let filterExits = !filter || (filter && !filter.includes('NA-Music'));

    if (filterExits) {
      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }

      filterEnabled = true;
    } else if (filterEnabled) {
      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }
      filterEnabled = false;
    }
  };

  const updateSortParam = async () => {
    if (sortBy) {
      if (sortBy === 'popularity') {
        sortParam = {
          sortingField: 'likes',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'recently_created') {
        sortParam = {
          sortingField: 'creationDate',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'price_low_to_high') {
        sortParam = {
          sortingField: 'price',
          sortingOrder: 'asc',
        };
      } else if (sortBy === 'price_high_to_low') {
        sortParam = {
          sortingField: 'price',
          sortingOrder: 'desc',
        };
      } else if (sortBy === 'alphabetically') {
        sortParam = {
          sortingField: 'tokenNameCaseInSensitivity',
          sortingOrder: 'asc',
        };
      }
      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }
    } else if (sortParam.sortingField !== 'creationDate') {
      sortParam = {
        sortingField: 'creationDate',
        sortingOrder: 'desc',
      };
      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }
    }
  };

  const updateRoomParam = async () => {
    if (roomFilter) {
      roomFilterBacked = true;
      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }
    } else if (roomFilterBacked) {
      roomFilterBacked = false;

      backedNftArr = [];
      startAfterDoc = null;
      if (!hasMore) {
        sethasMore(true);
      }
    }
  };

  const getData = async () => {
    sethardLoad(true);
    await getMarketPlaceData(true, callNo);
    sethardLoad(false);
  };

  useEffect(() => {
    if (searchQuery) {
      props.updateSearchInputEl(searchQuery);
    }
  }, [searchQuery]);

  return (
    <div className="w-full discover-screen2">
      <div>
        <Paper component="ul" className="filter_chip_chip flex flex-wrap ">
          {!hardLoad && (
            <>
              {renderChips()}
              {filters && filters.length > 0 && (
                <span
                  className="filter_clear_btn_btn"
                  onClick={() => clearAll()}
                >
                  Clear All
                </span>
              )}
            </>
          )}
        </Paper>
      </div>
      <InfiniteScroll
        loadMore={async () =>
          props.roomLoader ? '' : calledonce && (await getMarketPlaceData())
        }
        initialLoad={true}
        hasMore={hasMore}
        threshold={isMobile ? 5000 : 1500}
      >
        <div className="row row--grid " key="1">
          {(() => {
            if (
              nftDataArr.length === 0 &&
              hasMore === false &&
              !loadingNfts &&
              !hardLoad
            ) {
              return <div className="no__result__alert">No result found</div>;
            } else if (nftDataArr) {
              return (
                <>
                  {!hardLoad &&
                    nftDataArr.map((ele, index) => {
                      return (
                        <div
                          style={{ display: 'block' }}
                          className="turning-screens-discover 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12"
                          key={'nft-' + index + ele.tokenId}
                        >
                          <NftCard
                            nftDataArr={nftDataArr}
                            ele={ele}
                            index={index}
                            setnftDataArr={setNFTDataArr}
                            fetchArtist={false}
                          />
                        </div>
                      );
                    })}

                  {(() => {
                    if (hardLoad || hasMore) {
                      return skeleTonJson.map((ele, index) => (
                        <div
                          style={{ display: 'block' }}
                          className="turning-screens-discover 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12"
                          key={'nft-' + index + ele.tokenId}
                        >
                          <NftCard
                            // nftDataArr={nftDataArr}
                            ele={ele}
                            index={index}
                            fetchArtist={false}
                            // setNFTDataArr={setNFTDataArr}
                            category={'discover_nft_container'}
                          />
                        </div>
                      ));
                    }
                  })()}
                </>
              );
            }
          })()}
        </div>
      </InfiniteScroll>
    </div>
  );
}
